import * as PIXI from 'pixi.js';
import AssetManager from '../Game/Base/AssetManager';
import GSObject from '../Game/Base/GSObject';

export default class Particle extends GSObject {
    constructor(gsoParent, position, image = 'img.particle_coin', text = '') {
        super(gsoParent);
        this.particleOverlay = gsoParent;

        this.pixiContainer = null;
        this.sprite = null;

        this.spawnPosition = position.copy();
        this.image = image;
        this.text = text;
    }

    onCreateVisuals() {
        this.pixiContainer = new PIXI.Container();

        this.pixiContainer.position.x = this.spawnPosition.x;
        this.pixiContainer.position.y = this.spawnPosition.y;

        this.sprite = new PIXI.Sprite(AssetManager.get(this.image), 21, 21);
        this.sprite.anchor.set(0, 0.5);

        this.pixiContainer.addChild(this.sprite);

        this.pixiText = new PIXI.Text(this.text, {
            fontFamily: 'font_retro_gaming,Arial',
            fontSize: 46,
            fill: 0xfff200,
            align: 'left',
            lineJoin: 'round',
            stroke: 'black',
            strokeThickness: 4
        });
        this.pixiText.width = (Math.round(this.pixiText.width / 2) * 2) / 2;
        this.pixiText.height = (Math.round(this.pixiText.height / 2) * 2) / 2;
        this.pixiText.roundPixels = true;
        this.pixiText.anchor.set(0, 0.5);
        this.pixiText.position.x = 21;

        const totalWidth = this.pixiText.width / 2 + 21;
        this.pixiContainer.position.x -= totalWidth / 2;

        this.pixiContainer.addChild(this.pixiText);

        this.particleOverlay.pixiContainer.addChild(this.pixiContainer);
    }

    onUpdateVisuals() {
        this.pixiContainer.position.y -= (this.getGame().deltaTime / 100) * 2;
        this.pixiContainer.alpha -= this.getGame().deltaTime / 1000;
        if (this.pixiContainer.alpha < 0) {
            this.destroy();
        }
    }

    onDestroyVisuals() {
        this.pixiContainer.destroy();
    }
}
